<template>

    <div id="ListarTurmasPresenciais">

        <vuestic-widget headerText="Turmas Teóricas Presenciais">

            <div class="row">
                <fieldset class="col-md-6" id="dataAtualizar">
                    <legend>Data</legend>
                    <div class="form-group">
                        <div class="col-md-12 p-0 pr-2">
                            <input type="date" class="form-control border rounded pl-2 pr-2" v-model="dataAtualizar">
                        </div>
                    </div>
                </fieldset>

                <div class="col-md-6 text-right">
                    <legend class="espacamento-oculto">.</legend>
                    <button class="btn btn-info col-12 btn-micro" @click="updateClasses()">
                        <i id="consultButton" class="fa fa-refresh pr-3 icon-branco"></i>
                        <span class="font-button-modified">Atualizar Turmas</span>
                    </button>
                </div>
            </div>

            <div class="row pt-3">

                <fieldset class="col-md-4 mb-3">
                    <legend>Autoescola</legend>
					<model-select :options="selectCFC" v-model="selectedCFC" placeholder="Selecione um aluno"></model-select>
                </fieldset>

                <fieldset class="col-md-5" id="periodoConsultado">
                    <legend>Período a Ser Consultado</legend>
                    <div class="form-group">
                        <div class="col-md-6 p-0 pr-2">
                            <input type="date" class="form-control border rounded pl-2 pr-2" v-model="dataInicio">
                        </div>
                        <div class="col-md-6 p-0 pl-2">
                            <input type="date" class="form-control border rounded pl-2 pr-2" v-model="dataFim">
                        </div>
                    </div>
                </fieldset>

                <fieldset class="col-md-3" id="filtroAlunos">
                    <legend>Filtrar Alunos</legend>
                    <select v-model="filterStudent" class="custom-select border">
                        <option v-for="item in filterStudents" :value="item.value" :key="item.text">
                            {{ item.text }}
                        </option>
                    </select>
                </fieldset>

                <fieldset class="col-md-3 mb-3" id="agrupamento">
                    <legend class="m-0 d-flex">
                        <span>Agrupamento</span>
                        <div class="switch__container pl-3">
                            <input id="switch-shadow_codigo" v-model="toggleAgrupamento" class="switch switch--shadow" type="checkbox">
                            <label for="switch-shadow_codigo"></label>
                        </div>
                    </legend>
                    <div class="form-group">
                        <input type="text" class="form-control pt-0 pl-2 border rounded" id="nome_aluno" v-model="agrupamento">
                    </div>
                </fieldset>

                <div class="col-md-3 text-right">
                    <legend class="espacamento-oculto">.</legend>
                    <button class="btn btn-danger col-12 btn-micro" @click="clearInputs()">
                        <i id="clearButton" class="fa fa-trash pr-3 icon-branco"></i>
                        <span class="font-button-modified">Limpar</span>
                    </button>
                </div>

                <div class="col-md-3 text-right" v-if="loadTable">
                    <legend class="espacamento-oculto">.</legend>
                    <button class="btn btn-info col-12 btn-micro disabled" aria-disabled="true" @click="loadingData()">
                        <i id="consultButton" class="fa fa-search pr-3 icon-branco"></i>
                        <span class="font-button-modified">Consultar</span>
                    </button>
                </div>

                <div class="col-md-3 text-right" v-else>
                    <legend class="espacamento-oculto">.</legend>
                    <button class="btn btn-info col-12 btn-micro" @click="loadData()">
                        <i id="consultButton" class="fa fa-search pr-3 icon-branco"></i>
                        <span class="font-button-modified">Consultar</span>
                    </button>
                </div>

            </div>

            <div class="row mt-3" id="tabela">

                <div class="col-md-12">

                    <div v-if="loadTable" class="d-flex justify-content-center">
                        <component
                            :animation-duration="1000"
                            :is="'SpringSpinner'"
                            :color="'#4AE387'"
                            :size="80"
                            >
                        </component>
                    </div>
                    <table v-else class="table table-striped table-bordered table-responsive-sm text-center">
                        <thead>
                            <tr>
                                <th>Agrupamento</th>
                                <th>Início</th>
                                <th>Fim</th>
                                <th>Alunos Regulares</th>
                                <th>Alunos Reposição</th>
                                <th>Status</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="turmas.length === 0">
                                <td colspan="7">Nenhum Registro Encontrado</td>
                            </tr>
                            <tr v-for="(turma, index) in turmas" :key="index">
                                <td>
                                    {{ turma.id_agrupamento }}
                                </td>
                                <td>
                                    {{ turma.data_inicio | DateBRFilter  }}
                                </td>
                                <td>
                                    {{ turma.data_fim | DateBRFilter  }}
                                </td>
                                <td>
                                    {{ turma.quantidade_alunos }}
                                </td>
                                <td>
                                    {{ turma.reposicao_alunos.length }}
                                </td>
                                <td v-if="turma.finalizada === true && turma.cancelada === false">
                                    Finalizada
                                </td>
                                <td v-else-if="turma.finalizada === false && turma.cancelada === false && turma.coleta_informada === true">
                                    Realizada
                                </td>
                                <td v-else>
                                    Cancelada
                                </td>
                                <td>
                                    <!-- VISUALIZAR & EDITAR -->
                                    <button @click="showModalTurma(turma)" class="btn btn-info btn-micro mr-1">
                                        <i class="fa fa-info"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>

        </vuestic-widget>

        <!--//Modals-->

        <vuestic-modal ref="modalPresencasTurma" v-bind:large="true" id="modalTurma">

                <div slot="title">Informações</div>
                <vuestic-tabs :names="['Dados Básicos','Alunos Regulares','Alunos Reposição', 'Aulas', 'Presenças']" ref="tabs">
                    <div slot="Dados Básicos">

                        <div class="row text-center" v-if="!!turmaSelected.id_agrupamento">

                            <fieldset class="col-md-4">
                                <strong class="font-weight-bold">Agrupamento:</strong>
                                <p>
                                    {{ turmaSelected.id_agrupamento }}
                                </p>
                            </fieldset>

                            <fieldset class="col-md-4">
                                <strong class="font-weight-bold">Data de Início:</strong>
                                <p>
                                    {{ turmaSelected.data_inicio | DateBRFilter }}
                                </p>
                            </fieldset>

                            <fieldset class="col-md-4">
                                <strong class="font-weight-bold">Data de Finalização:</strong>
                                <p>
                                    {{ turmaSelected.data_fim | DateBRFilter }}
                                </p>
                            </fieldset>

                        </div>

                        <hr>

                        <div class="row text-center">

                            <fieldset class="col-md-4">
                                <div v-if="loadButtonCancelar" class="d-flex justify-content-center">
                                    <component
                                        :animation-duration="1000"
                                        :is="'SpringSpinner'"
                                        :color="'#4AE387'"
                                        :size="30"
                                        >
                                    </component>
                                </div>
                                <div v-else>
                                    <button type="button" @click="cancelarTurma()" class="btn btn-micro btn-danger">Cancelar Turma</button>
                                </div>
                            </fieldset>

                            <fieldset class="col-md-4">
                                <button type="button" @click="updateQuery()" class="btn btn-micro btn-info">Atualizar Status</button>
                            </fieldset>

                            <fieldset class="col-md-4">
                                <button type="button" @click="enviarBiometriaVirtual(turmaSelected)" class="btn btn-micro btn-info">Enviar Biometria</button>
                            </fieldset>

                        </div>

                    </div>

                    <div slot="Alunos Regulares">

                        <div v-if="loadAlunosRegulares" class="row text-center d-flex justify-content-center">
                            <component
                                :animation-duration="1000"
                                :is="'SpringSpinner'"
                                :color="'#4AE387'"
                                :size="80"
                                >
                            </component>
                            <div class="col-md-12 mt-3">
                                <strong class="font-weight-bold">Pode demorar um pouco...</strong>
                            </div>
                        </div>
                        <div v-else class="row text-center">

                            <table class="table table-striped table-bordered table-responsive-sm text-center">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>CPF</th>
                                        <th>Renach</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="turmaDetail.alunos_regulares && turmaDetail.alunos_regulares.length === 0">
                                        <td colspan="3">Nenhum Registro Encontrado</td>
                                    </tr>
                                    <tr v-else v-for="(turma, index) in turmaDetail.alunos_regulares" :key="index">
                                        <td>
                                            {{ turma.nome }}
                                        </td>
                                        <td>
                                            {{ turma.cpf | CpfCnpjFilter }}
                                        </td>
                                        <td>
                                            {{ turma.renach }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                    </div>

                    <div slot="Alunos Reposição">

                        <div v-if="loadAlunosReposicao" class="row text-center d-flex justify-content-center">
                            <component
                                :animation-duration="1000"
                                :is="'SpringSpinner'"
                                :color="'#4AE387'"
                                :size="80"
                                >
                            </component>
                            <div class="col-md-12 mt-3">
                                <strong class="font-weight-bold">Pode demorar um pouco...</strong>
                            </div>
                        </div>
                        <div v-else class="row text-center">

                            <table class="table table-striped table-bordered table-responsive-sm text-center">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>CPF</th>
                                        <th>Renach</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="turmaDetail.alunos_reposicao && turmaDetail.alunos_reposicao.length === 0">
                                        <td colspan="3">Nenhum Registro Encontrado</td>
                                    </tr>
                                    <tr v-else v-for="(turma, index) in turmaDetail.alunos_reposicao" :key="index">
                                        <td>
                                            {{ turma.nome }}
                                        </td>
                                        <td>
                                            {{ turma.cpf | CpfCnpjFilter }}
                                        </td>
                                        <td>
                                            {{ turma.renach }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                    </div>

                    <div slot="Aulas">

                        <div v-if="loadAulasTeoricas" class="row text-center d-flex justify-content-center">
                            <component
                                :animation-duration="1000"
                                :is="'SpringSpinner'"
                                :color="'#4AE387'"
                                :size="80"
                                >
                            </component>
                            <div class="col-md-12 mt-3">
                                <strong class="font-weight-bold">Pode demorar um pouco...</strong>
                            </div>
                        </div>
                        <div v-else class="row text-center">

                            <table class="table table-striped table-bordered table-responsive-sm text-center">
                                <thead>
                                    <tr>
                                        <th>Instrutor</th>
                                        <th>Matéria</th>
                                        <th>Início</th>
                                        <th>Fim</th>
                                        <th>Duração</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="turmaDetail.aulas && turmaDetail.aulas.length === 0">
                                        <td colspan="3">Nenhum Registro Encontrado</td>
                                    </tr>
                                    <tr v-else v-for="(aula, index) in turmaDetail.aulas" :key="index">
                                        <td>
                                            {{ turmaDetail.instrutor.nome }}
                                        </td>
                                        <td>
                                            {{ aula.materia.titulo }}
                                        </td>
                                        <td>
                                            {{ aula.inicio | DateBRFilter }}
                                        </td>
                                        <td>
                                            {{ aula.fim | DateBRFilter }}
                                        </td>
                                        <td>
                                            {{ aula.duracao_minutos }} minutos
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                    </div>

                    <div slot="Presenças">

                        <div v-if="loadPresencasTeoricas" class="row text-center d-flex justify-content-center">
                            <component
                                :animation-duration="1000"
                                :is="'SpringSpinner'"
                                :color="'#4AE387'"
                                :size="80"
                                >
                            </component>
                            <div class="col-md-12 mt-3">
                                <strong class="font-weight-bold">Pode demorar um pouco...</strong>
                            </div>
                        </div>
                        <div v-else class="row text-center">

                            <div class="col-md-12">

                                <i class="fa fa-circle danger pl-2 pr-2"></i>
                                <span>AUSENTE</span>

                                <i class="fa fa-circle primary pl-2 pr-2"></i>
                                <span>PRESENTE (ENTRADA)</span>

                                <i class="fa fa-circle success pl-2 pr-2"></i>
                                <span>PRESENTE</span>

                            </div>

                            <table class="table table-striped table-bordered table-responsive-sm text-center mt-3">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>CPF</th>
                                        <th>Entidade</th>
                                        <th>Presença</th>
                                        <th>Status</th>
                                        <th>Foto Presença</th>
                                        <th>Dispositivo</th>
                                        <!-- <th>Adicionar Presença</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="aulasTeoricas === null">
                                        <td colspan="8">Nenhum Registro Encontrado</td>
                                    </tr>
                                    <tr v-else v-for="(presenca, index) in presencas" :key="index">
                                        <td>
                                            {{ presenca.nome }}
                                        </td>
                                        <td>
                                            {{ presenca.cpf | CpfCnpjFilter }}
                                        </td>
                                        <td>
                                            {{ presenca.entidade }}
                                        </td>
                                        <td v-if="presenca.presencas && presenca.presencas.length === 0">
                                            <i class="fa fa-circle danger pl-2 pr-2"></i>
                                        </td>
                                        <td v-else>
                                            <span v-for="(teste, index) in presenca.presencas" :key="index">

                                                <!-- PRESENCA (ENTRADA & SAÍDA) -->
                                                <span v-if="teste.tipo === 'INICIO' && 'FIM' ">
                                                    <i class="fa fa-circle success pl-2 pr-2"></i>
                                                </span>
                                                <!-- PRESENCA (ENTRADA) -->
                                                <span v-if="teste.tipo === 'INICIO' && !teste.tipo === 'FIM' ">
                                                    <i class="fa fa-circle primary pl-2 pr-2"></i>
                                                </span>

                                            </span>
                                        </td>
                                        <td v-if="presenca.presencas && presenca.presencas.length === 0">
                                            SEM PRESENÇA
                                        </td>
                                        <td v-else>
                                            <span v-if="presenca.entidade === 'INSTRUTOR' ">
                                                INSTRUTOR
                                            </span>
                                            <span v-else>
                                                {{ presenca.presencas[0].status }}
                                            </span>
                                        </td>
                                        <td>
                                            <span v-if="presenca.presencas && presenca.presencas.length === 0">
                                                AUSENTE
                                            </span>
                                            <span v-else>
                                                <a @click="getPresencas(presenca)">
                                                    <i class="fa fa-picture-o pl-2 pr-2"></i>
                                                </a>
                                            </span>
                                        </td>
                                        <td>
                                            -
                                        </td>
                                        <!-- <td>
                                            <span v-if="presenca.presencas && presenca.presencas.length === 0">
                                                <a @click="setPresencas(presenca)">
                                                    <span class="fa fa-plus"></span>
                                                </a>
                                            </span>
                                            <span v-else>
                                                <a>
                                                    <span class="fa fa-plus disabled"></span>
                                                </a>
                                            </span>
                                        </td> -->
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                    </div>

                </vuestic-tabs>
        </vuestic-modal>

    </div>
</template>

<script>
import urlApiV2 from '@/router/urlApiV2'
import urlApi from '@/router/urlApi'
import * as spinners from 'epic-spinners'
import TurmasTeoricasController from './TurmasTeoricasController'
import MonitoriaController from '../MonitoriaController'
import { ModelSelect } from 'vue-search-select'

export default {
    name: 'ListarPresenciais',
    components: {
        urlApiV2,
        ...spinners,
        ModelSelect
    },

    data () {
        return {
            loadButtonCancelar: false,
            loadAlunosRegulares: false,
            loadAlunosReposicao: false,
            loadAulasTeoricas: false,
            loadPresencasTeoricas: false,
            aulasTeoricas: false,
            selectedCFC: '',
            selectCFC: [],
            turmaDetail: [],
            turmas: [],
            turmaSelected: [],
            agrupamento: '',
            loadTable: false,
            toggleAgrupamento: false,
            dataInicio: '',
            dataFim: '',
            filterStudent: '',
            filterStudents: [],
            turmas: [],
            dataAtualizar: '',
            presencas: [],
        }
    },

    created() {

        //CARREGAR CFC's
        MonitoriaController.loadCfc().then(res => {
            this.selectCFC = res;
        });

        // CARREGAR ORDENAÇÕES
        TurmasTeoricasController.filterStudents().then(res => {
            this.filterStudents = res;
        });

    },

    methods: {

        clearInputs()
        {
            this.loadTable = ''
            this.dataInicio = ''
            this.dataFim = ''
            this.agrupamento = ''
            this.selectedCFC = ''
            this.filterStudent = ''
            this.turmas = ''
            this.toggleAgrupamento = false;
            document.getElementById('periodoConsultado').disabled = false;
            document.getElementById('filtroAlunos').disabled = false;
        },

        loadingData()
        {
            this.launchToast('Aguarde a última consulta ser concluída!')
        },

        loadData()
        {
            const schema = this.selectedCFC
            const periodo = [ this.dataInicio, this.dataFim ]
            const filtroAlunos = this.filterStudent ? this.filterStudent : null
            const agrupamento = this.agrupamento

            this.selected = [];
            this.loadTable = true;

            var data = this.validateInputs(schema, periodo, filtroAlunos, agrupamento)

            // FILTRAR BUSCA
            TurmasTeoricasController.loadDataPresenciais(data, (response) => {
                this.turmas = response;
                this.loadTable = false;
            });
        },

        validateInputs(schema, periodo, filtroAlunos, agrupamento)
        {

            if(schema === '')
            {
                this.launchToast('Selecione uma Autoescola!')
                this.loadTable = false;
                return;
            }

            //* CONSULTA PELO AGRUPAMENTO
            if(this.toggleAgrupamento) {
                if(agrupamento === '') {
                    this.launchToast('Informe o Agrupamento!')
                    this.loadTable = false;
                    return;
                }
                var data = {
                    schema: schema,
                    agrupamento: agrupamento,
                }
            } else {
                var data = {
                    schema: schema,
                    filtroAlunos: filtroAlunos,
                    periodo: periodo
                }
            }

            this.loadTable = true;
            return data;
        },

        updateClasses () {
            if(this.selectedCFC == '')
            {
                this.launchToast('Selecione uma Autoescola!')
                return;
            }
            if (this.dataAtualizar == '') {
                this.launchToast('Nenhuma Data Selecionada!')
                return
            }

            this.$http.get(urlApiV2 + `/getran/atualizar/turmas?schema=${this.selectedCFC}&date=${this.dataAtualizar}`)
            .then(function (response) {
                this.launchToast(response.data.mensagem)
                this.dataInicio = this.dataAtualizar
                this.dataFim = this.dataAtualizar
                this.loadData();
                console.log(response)
            })
            .catch(function (error) {
                this.launchToast(error.data.mensagem)
                console.log(error)
            })
        },

        showModalTurma(turma)
        {
            this.turmaSelected = turma;

            this.loadAlunosRegulares = true;
            this.loadAlunosReposicao = true;
            this.loadAulasTeoricas = true;
            this.loadPresencasTeoricas = true;

            // ABRIR MODAL
            this.$refs.modalPresencasTurma.open();

            this.loadDataClass(turma);
        },

        loadDataClass(turma)
        {
            var data = { schema: this.selectedCFC, turma: turma }
            TurmasTeoricasController.loadDataClass(data, (response) => {
                this.turmaDetail = response;

                this.presencas = [];
                this.listPresencas(response);

                console.log(this.presencas)

                this.loadAlunosRegulares = false;
                this.loadAlunosReposicao = false;
                this.loadAulasTeoricas = false;
                this.loadPresencasTeoricas = false;
            });
        },

        listPresencas(response)
        {
            response.alunos_reposicao.length > 0 ? response.alunos_reposicao.forEach(element => {
                this.presencas.push({
                    id: element.id_aluno ? element.id_aluno : '',
                    nome: element.nome,
                    cpf: element.cpf,
                    entidade: 'ALUNO',
                    status: element.status,
                    presencas: element.presencas ? element.presencas : '',
                    dispositivo: '',
                })
            }) : '';

            response.alunos_regulares.length > 0 ? response.alunos_regulares.forEach(element => {
                this.presencas.push({
                    id: element.id_aluno ? element.id_aluno : '',
                    nome: element.nome,
                    cpf: element.cpf,
                    entidade: 'ALUNO',
                    status: element.status,
                    presencas: element.presencas ? element.presencas : '',
                    dispositivo: '',
                })
            }) : '';

            response.instrutor ? this.presencas.push({
                id: response.instrutor.id_instrutor ? response.instrutor.id_instrutor : '',
                nome: response.instrutor.nome,
                cpf: response.instrutor.cpf,
                entidade: 'INSTRUTOR',
                status: response.instrutor.status,
                presencas: response.instrutor.presencas,
                dispositivo: '',
            }) : '';
        },

        updateQuery()
        {
            // FECHAR MODAL
            this.$refs.modalPresencasTurma.close();
            this.loadData();
        },

        setPresencas()
        {
            this.launchToast('Ação não disponível para turma presencial')
        },

        getPresencas(presenca)
        {
            this.launchToast('Consulta não disponível para turma presencial')
        },

        cancelarTurma (turmaSelected)
        {
            this.loadButtonCancelar = true;
            var data = { turma: turmaSelected, schema: this.selectedCFC }
            ListarTurmasVirtuaisController.cancelarTurma(data, (response) => {
                console.log(response.data.mensagem);

                // TOASTED
                this.$toasted.show(response.data.mensagem, {
                    position: 'top-right',
                });

                // FECHAR MODAL
                this.$refs.modalPresencasTurma.close();


                this.loadData();

                this.loadButtonCancelar = false;
            });
        },

        launchToast(mensagem)
        {
            this.$toasted.show(mensagem, {
                position: 'top-right',
            });
        }
    },

    watch: {

        dataInicio(nova, antiga)
        {
            if(nova != '' && this.dataFim != ''){
                if(new Date(nova) > new Date(this.dataFim)){
                    this.launchToast('Data Inicial Deve Ser Menor do Que Data Final')
                    this.dataInicio = '';
                }
            }
        },

        dataFim(nova, antiga)
        {
            if(nova != '' && this.dataInicio != ''){
                if(new Date(nova) < new Date(this.dataInicio)){
                    this.launchToast('Data Final Deve Ser Maior do Que Data Inicial')
                    this.dataFim = '';
                }
            }
        },

        toggleAgrupamento(novo, antigo)
        {
            if(novo === true)
            {
                this.launchToast('Consulta Pelo Agrupamento')

                document.getElementById('periodoConsultado').disabled = true;
                document.getElementById('filtroAlunos').disabled = true;
            } else
            {
                document.getElementById('periodoConsultado').disabled = false;
                document.getElementById('filtroAlunos').disabled = false;
            }
        }
    }

}
</script>

<style lang="scss">

    #ListarTurmasPresenciais {

        #modalTurma {

            .disabled
            {
                background-color: #ffc30e85 !important;
                user-select: none;
                cursor: default;
            }

            .modal-lg .modal-footer
            {
                display: none !important;
            }

            // ÍCONES DE STATUS
            .fa-circle.success
            {
                color: #20c997;
            }

            .fa-circle.primary
            {
                color: #ffc20e;
            }

            .fa-circle.danger
            {
                color: #dc3545;
            }

            .fa-picture-o, .fa-plus
            {
                width: 35px;
                height: 35px;
                color: white;
                background-color: #ffc20e;
                border-color: #ffc20e;
                border-radius: 100%;
                margin: 0 auto;
                padding: 10px;
                box-shadow: black;
            }

            .fa-picture-o:hover, .fa-plus:hover
            {
            background-color: #ffc30e79;
            }

            td
            {
                width: auto;
            }

        }

        #modalPresencaAluno {

            .modal {
                box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, .30);
            }

            .modal-footer {
                display: none;
            }
        }

        #tabela {

            td {
                width: auto !important;
            }

            .fa {
                height: 0px;
                width: 15px;
            }

            .btn {
                letter-spacing: 0px !important;
            }

            .btn.btn-micro {
                padding: 0.5rem !important;
                line-height: 1 !important;
                border-radius: 100% !important;
            }

        }

        input.form-control {
            height: 36px;
            margin-top: -3.5px;
        }

        .espacamento-oculto {
            color: transparent;
            user-select: none;
        }

        /* Estilo iOS */
        .switch {
            visibility: hidden;
            position: absolute;
            margin-left: -9999px;
        }

        .switch + label {
            display: inline-flex;
            position: relative;
            cursor: pointer;
            outline: none;
            user-select: none;
        }

        .switch--shadow + label {
            padding: 2px;
            width: 60px;
            height: 31px;
            background-color: #dddddd;
            border-radius: 30px;
            margin: 0;
        }

        .switch--shadow + label:before,
        .switch--shadow + label:after {
            display: block;
            position: absolute;
            top: 1px;
            left: 1px;
            bottom: 1px;
            content: "";
        }

        .switch--shadow + label:before {
            right: 1px;
            background-color: #f1f1f1;
            border-radius: 30px;
            transition: background 0.4s;
        }

        .switch--shadow + label:after {
            width: 28px;
            background-color: #fff;
            border-radius: 50%;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
            transition: all 0.4s;
        }

        .switch--shadow:checked + label:before {
            background-color: #8ce196;
        }

        .switch--shadow:checked + label:after {
            transform: translateX(30px);
        }

    }

</style>
